var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPrefixSnapshot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "10fbj5cuda"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.235294 0 0 0 0 0.364706 0 0 0 0 0.949020 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "w68m60nk2b"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15 -8)",
    filter: "url(#10fbj5cuda)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 8)",
    filter: "url(#w68m60nk2b)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#8793A3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.958 5.833V9.5 5.833zM16.042 5.833v8.25-8.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.042 14.083c0 1.013-2.258 1.834-5.042 1.834",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.042 8.583c0 1.013-2.258 1.834-5.042 1.834M16.042 11.333c0 .881-1.71 1.617-3.988 1.794M16.042 5.833c0 1.013-2.258 1.834-5.042 1.834s-5.042-.821-5.042-1.834",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.042 5.833C16.042 4.821 13.784 4 11 4s-5.042.82-5.042 1.833"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#B6BFCE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9a4 4 0 1 1 0 8 4 4 0 0 1 0-8z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.327 13.939 8 13.286V11"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPrefixSnapshot);
export default __webpack_public_path__ + "static/media/ico-prefix-snapshot.4ad2b476ea0085188e754b1ccc8883f8.svg";
export { ForwardRef as ReactComponent };